(() => {
  // Navigation only: no access to search forms, facets or their URL state.
  if (window.beCategoryNavigation) return;
  const pending = new Map();
  const resolved = new Map();

  function apply(handle, data) {
    const counts = new Map(data.types.map(item => [item.value, item.count]));
    document.querySelectorAll('[data-be-nav-group]').forEach(group => {
      if (group.dataset.beNavGroup !== handle) return;
      const hasDestination = !group.hasAttribute('data-be-nav-all') || group.dataset.beNavAll === 'all' ||
        (group.dataset.beNavTypes || '').split(',').some(type => (counts.get(type) || 0) > 0);
      group.hidden = data.count === 0 || !hasDestination;
      group.querySelectorAll('[data-be-nav-total]').forEach(node => {
        node.textContent = `（${data.count}）`;
      });
      group.querySelectorAll('[data-be-nav-type]').forEach(item => {
        // Cross-classified outbath products use the collection's total, not a type facet.
        if (item.dataset.beNavCollection) return;
        const count = counts.get(item.dataset.beNavType) || 0;
        item.hidden = count === 0;
        const label = item.querySelector('[data-be-nav-count]');
        if (label) label.textContent = `（${count}）`;
      });
    });
    document.querySelectorAll('[data-be-nav-collection]').forEach(item => {
      if (item.dataset.beNavCollection !== handle) return;
      item.hidden = data.count === 0;
      const label = item.querySelector('[data-be-nav-count]');
      if (label) label.textContent = `（${data.count}）`;
    });
    document.querySelectorAll('.global-menu').forEach(menu => {
      let position = 0;
      [...menu.children].filter(item => item.hasAttribute('data-be-nav-group')).forEach(item => {
        [...item.classList].filter(name => /^global-item-\d+$/.test(name)).forEach(name => item.classList.remove(name));
        if (!item.hidden) item.classList.add(`global-item-${++position}`);
      });
    });
  }

  async function load(handle, path, category) {
    if (pending.has(handle)) return pending.get(handle);
    const task = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(path, location.origin);
        if (url.origin !== location.origin || !path) throw new Error('Missing collection');
        // An unfiltered request keeps navigation independent of current filters.
        url.search = '';
        if (category) url.searchParams.set('filter.p.m.custom.categories', category);
        url.searchParams.set('view', 'be-nav-counts');
        const response = await fetch(url, {signal: controller.signal, cache: 'no-store'});
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (data.handle !== (category ? 'all' : handle) || (category && (!Array.isArray(data.categories) || !data.categories.includes(category))) || data.available !== true || !Number.isInteger(data.count) || data.count < 0 || !Array.isArray(data.types) || data.types.some(item => typeof item.value !== 'string' || !Number.isInteger(item.count) || item.count < 0)) {
          throw new Error('Invalid category counts');
        }
        resolved.set(handle, data);
        apply(handle, data);
      } catch (error) {
        // A failure is not zero: keep the last valid result and allow retry.
        console.warn('[Category navigation] Counts unavailable:', handle, error.message);
      } finally {
        clearTimeout(timeout);
        pending.delete(handle);
      }
    })();
    pending.set(handle, task);
    return task;
  }

  const colorCarePending = new Map();
  const colorCareResolved = new Map();

  async function refreshColorCare(force) {
    const destinations = new Map();
    document.querySelectorAll('[data-be-nav-color-care]').forEach(item => {
      const link = item.querySelector('a');
      const label = item.querySelector('[data-be-nav-color-care-count]');
      if (!link || !label) return;
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.searchParams.get('filter.p.m.custom.concerns') !== 'カラーケア・色持ち') return;
      url.searchParams.set('view', 'be-nav-counts');
      const key = url.href;
      if (!destinations.has(key)) destinations.set(key, []);
      destinations.get(key).push(label);
    });
    await Promise.all([...destinations].map(async ([url, labels]) => {
      if (force || !colorCareResolved.has(url)) {
        if (!colorCarePending.has(url)) {
          colorCarePending.set(url, (async () => {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 15000);
            try {
              const response = await fetch(url, {signal: controller.signal, cache: 'no-store'});
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              const data = await response.json();
              const handle = new URL(url).pathname.split('/').filter(Boolean).pop();
              if (data.handle !== handle || data.available !== true || !Number.isInteger(data.count) || data.count < 0) throw new Error('Invalid color care count');
              colorCareResolved.set(url, data.count);
            } catch (error) {
              // Do not turn a failed request into a zero count.
              console.warn('[Category navigation] Color care count unavailable:', error.message);
            } finally {
              clearTimeout(timeout);
              colorCarePending.delete(url);
            }
          })());
        }
        await colorCarePending.get(url);
      }
      if (colorCareResolved.has(url)) labels.forEach(label => { label.textContent = `（${colorCareResolved.get(url)}）`; });
    }));
  }

  async function refresh(force = false) {
    const groups = new Map();
    document.querySelectorAll('[data-be-nav-group]').forEach(group => {
      groups.set(group.dataset.beNavGroup, {path:group.dataset.beNavUrl, category:group.dataset.beNavCategory});
    });
    document.querySelectorAll('[data-be-nav-collection]').forEach(item => {
      groups.set(item.dataset.beNavCollection, {path:item.dataset.beNavUrl});
    });
    const queue = [...groups];
    const worker = async () => {
      while (queue.length) {
        const [handle, {path, category}] = queue.shift();
        if (!force && resolved.has(handle)) apply(handle, resolved.get(handle));
        else await load(handle, path, category);
      }
    };
    // Share one request per collection across all three surfaces; at most 3 at once.
    await Promise.all([worker(), worker(), worker(), refreshColorCare(force)]);
  }
  window.beCategoryNavigation = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), {once: true});
  else refresh();
  document.addEventListener('shopify:section:load', () => refresh());
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(true); });
  window.addEventListener('online', () => refresh(true));
  document.addEventListener('toggle', event => {
    if (event.target.id === 'Details-menu-drawer-top-categories' && event.target.open) refresh();
  }, true);
})();
